import React, { useState } from "react";
import { X, Heart } from "lucide-react";

const DonationPopup: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={handleClose}
      />

      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-2xl w-full p-8 md:p-12 transform animate-in fade-in zoom-in-95 duration-300">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 p-2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
        >
          <X size={24} />
        </button>

        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full mb-6 shadow-lg">
            <Heart className="text-white" size={40} />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white mb-4">
            Support devagile.tools
          </h2>

          <div className="space-y-4 text-gray-600 dark:text-gray-300 text-left max-w-lg mx-auto mb-8">
            <p>
              <strong>Thank you for using devagile.tools!</strong> If you use
              this site daily, I would really appreciate a small contribution to
              help cover the domain costs.
            </p>
            <p>
              The site will <strong>always remain free</strong> with no
              subscription required. Your support helps keep this project alive!
            </p>
            <p>
              💡 <strong>Goal:</strong> If we manage to raise enough to pay for
              a year of domain together, I'm committed to improving the project
              with new features and a better UI. Your ideas matter!
            </p>
            <p>
              Feel free to leave a comment with your suggestions or feature
              requests. I'm open to building what the community needs!
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://ko-fi.com/rubendepaz1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#00b9fe] hover:bg-[#0099d4] text-white text-lg font-semibold rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:scale-105"
            >
              ☕ Donate or Comment on Ko-fi
            </a>
          </div>

          <p className="mt-4 text-sm text-gray-500 dark:text-gray-400">
            You can also leave a comment on Ko-fi without donating - your
            feedback matters!
          </p>

          <p className="mt-6 text-sm text-gray-500 dark:text-gray-400">
            Click outside or the X to close this popup
          </p>
        </div>
      </div>
    </div>
  );
};

export default DonationPopup;
